import * as React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode; fallback?: React.ReactNode },
  State
> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  override componentDidCatch(error: Error, info: React.ErrorInfo) {
    if (import.meta.env.PROD) {
      console.error('[ErrorBoundary]', error, info);
    }
  }

  reset = () => this.setState({ hasError: false, error: null });

  override render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="flex min-h-[60vh] items-center justify-center p-6">
          <div className="max-w-md text-center">
            <AlertTriangle
              className="mx-auto h-12 w-12 text-destructive"
              aria-hidden
            />
            <h2 className="mt-4 text-2xl font-bold">Algo ha ido mal</h2>
            <p className="mt-2 text-muted-foreground">
              {this.state.error?.message ?? 'Error inesperado'}
            </p>
            <Button onClick={this.reset} className="mt-6">
              <RefreshCw className="mr-2 h-4 w-4" />
              Reintentar
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
